import { render, staticRenderFns } from "./BadgePillNotification.vue?vue&type=template&id=99f265d6&"
import script from "./BadgePillNotification.vue?vue&type=script&lang=js&"
export * from "./BadgePillNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports